'use strict'
import ServiceExec from "@/common/utils/ServiceExec";

class CertSvc extends ServiceExec {
  getCertInfo(params = {}) {
    return this.queryPost('/api/app/cert/getCertInfo', params)
    .then(res => res.data)
  }

  registInquire(params = {}) {
    return this.queryPost('/api/app/cert/registInquire', params)
    .then(res => res.data)
  }
}

export default new CertSvc()
